import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NativeContextMenu" */ './lazyIndex'),
    { name: 'NativeContextMenu' }
);

export const lazyInitializeNativeContextMenu: LazyAction<
    typeof lazyIndex.initializeNativeContextMenu,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeNativeContextMenu);
